import * as React from "react";
import NProgress from "nprogress";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { useSelector } from "react-redux";

import Loader from "../atoms/Loader";
import ManageClubTitle from "../molecules/ManageClubTitle";
import { useGetGovernancesByClubQuery } from "../../services/wp";
import { format, parse } from "date-fns";
import { StatusPill } from "../atoms/StatusPill";

interface PropsType extends RouteComponentProps {
    id: any;
}

const ManageClubsGovernanceBody = (props: PropsType) => {
    const { data, isLoading, error } = useGetGovernancesByClubQuery(props.id);

    const { create_governance_form_link } = useSelector(
        (state: any): any => state.options
    );

    React.useEffect(() => {
        if (isLoading) {
            NProgress.start();
        } else {
            NProgress.done();
        }
    }, [isLoading]);

    return (
        <div className="row manage-clubs-governance-body">
            <div className="col-xs-12">
                <div className="row">
                    <div className="col-xs-12">
                        <ManageClubTitle
                            title="Governance"
                            ctaText="Apply for changes"
                            ctaUrl={create_governance_form_link.url}
                        />
                    </div>
                </div>
                <Loader active={isLoading}>
                    {error ? (
                        "An error has occurred. Please try again."
                    ) : data?.length === 0 ? (
                        "The club does not have any previous changes."
                    ) : (
                        <div className="manage-clubs-governance-body__list">
                            <div className="manage-clubs-governance-body__list__row-divider" />
                            {data?.map((governance, i) => {
                                const dateOfMeeting = governance.date_of_meeting
                                    ? parse(
                                          governance.date_of_meeting,
                                          "yyyy-MM-dd H:mm:ss",
                                          new Date()
                                      )
                                    : null;
                                const createdOn = governance.created_on
                                    ? parse(
                                          governance.created_on,
                                          "yyyy-MM-dd H:mm:ss",
                                          new Date()
                                      )
                                    : null;

                                return (
                                    <React.Fragment key={i}>
                                        <div className="manage-clubs-governance-body__list__item__property manage-clubs-governance-body__list__item__description">
                                            <div className="manage-clubs-governance-body__list__item__description__name">
                                                {governance.name}
                                            </div>
                                            <div className="manage-clubs-governance-body__list__item__description__date">
                                                <span className="manage-clubs-governance-body__list__item__description__date__label">
                                                    Meeting date:
                                                </span>
                                                {dateOfMeeting &&
                                                !isNaN(dateOfMeeting.valueOf())
                                                    ? format(
                                                          dateOfMeeting,
                                                          "d LLL y"
                                                      )
                                                    : ""}
                                            </div>
                                        </div>
                                        <div className="manage-clubs-governance-body__list__item__property manage-clubs-governance-body__list__item__applied">
                                            <div className="manage-clubs-governance-body__list__item__label">
                                                Date submitted
                                            </div>
                                            <div className="manage-clubs-governance-body__list__item__value">
                                                {createdOn &&
                                                !isNaN(createdOn.valueOf())
                                                    ? format(
                                                          createdOn,
                                                          "d LLL y"
                                                      )
                                                    : ""}
                                            </div>
                                        </div>
                                        <div className="manage-clubs-governance-body__list__item__status">
                                            {governance.status ? (
                                                <StatusPill
                                                    status={governance.status}
                                                />
                                            ) : null}
                                        </div>
                                        <div className="manage-clubs-governance-body__list__row-divider" />
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    )}
                </Loader>
            </div>
        </div>
    );
};

ManageClubsGovernanceBody.preload = ({
    location,
    passed: { store },
}: any): Promise<any> => {
    return Promise.all([]);
};

export default withRouter(ManageClubsGovernanceBody);
